import { BaseComponent2 } from '../../_common/client/base-component2';

export class OffersVariationNameComponent extends BaseComponent2 {
    public rootSelector = '.js_of_offers-variation-name';

    public async onPageLoaded(): Promise<void> {
        return;
    }

    public async onReloadComponentEvent(): Promise<unknown> {
        return Promise.resolve(undefined);
    }
}
